import { Alert, Platform } from 'react-native'

const alertForWeb = (title, description, options, extra) => {
    const result = window?.confirm([title, description].filter(Boolean).join('\n'))

    if (result) {
        const confirmOption = options.find(({ style }) => style !== 'cancel')
        confirmOption && confirmOption.onPress()
    } else {
        const cancelOption = options.find(({ style }) => style === 'cancel')
        cancelOption && cancelOption.onPress()
    }
}

const AlertPolyfill = Platform.OS === 'web' ? alertForWeb : Alert.alert
export default AlertPolyfill